import { ErrorHandler } from '@angular/core';

const CHUNK_ERROR_SIGNATURES = [
  'Failed to fetch dynamically imported module',
  'Loading chunk',
  'ChunkLoadError',
  'error loading dynamically imported module',
  'Importing a module script failed',
];

const RELOAD_FLAG = 'cuminanza_chunk_reload_at';
const RELOAD_COOLDOWN_MS = 30_000;

export class ChunkReloadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (this.isChunkLoadError(error) && this.canReload()) {
      sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
      this.doReload();
      return;
    }
    console.error(error);
  }

  protected doReload(): void {
    window.location.reload();
  }

  private isChunkLoadError(error: unknown): boolean {
    const message = this.extractMessage(error);
    if (!message) return false;
    return CHUNK_ERROR_SIGNATURES.some((sig) => message.includes(sig));
  }

  private extractMessage(error: unknown): string {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    if (typeof error === 'object' && 'message' in error) {
      return String((error as { message?: unknown }).message ?? '');
    }
    return String(error);
  }

  private canReload(): boolean {
    try {
      const previous = Number(sessionStorage.getItem(RELOAD_FLAG) ?? '0');
      return !previous || Date.now() - previous > RELOAD_COOLDOWN_MS;
    } catch {
      return true;
    }
  }
}
